   <template>
<div>
       <Header/>

<!--End mainmenu area--> 

<!--Start breadcrumb area-->

<section class="breadcrumb-area" v-bind:style="{backgroundImage: 'url('+this.pagebanner+ ')' }">
	<div class="container text-center">
		<h1 v-if="pagedata">{{ $i18n.locale == 'en' ? pagedata.page_entitle:pagedata.page_artitle }}</h1>
		<span class="border"></span>
	</div>
</section>
<!--End breadcrumb area-->
         
<!--Start breadcrumb bottom area--> 
<section class="breadcrumb-bottom-area">
    <div class="container">
        <div :class="$i18n.locale == 'en' ?'right pull-left': 'right pull-right'">
            <a href="#"></a>    
        </div>
        <div :class="$i18n.locale == 'en' ?'right pull-left': 'right pull-right'">
            <ul>
               <li><a :href="$i18n.locale == 'en' ? '../../../../en/': '../../../../ar/'">{{ $i18n.locale == 'en' ? 'Home':'الرئيسية' }}</a></li>
               <li>></li>
                <li><a href="#">{{ $i18n.locale == 'en' ? pagedata.page_entitle:pagedata.page_artitle }}</a></li>

                
            </ul>    
        </div>        
    </div>    
</section>         
<!--End breadcrumb bottom area-->
         
<!--Start faq content area-->
  <p v-html="$i18n.locale == 'en' ? pagedata.pagecontenten: pagedata.pagecontentar"> {{ $i18n.locale == 'en' ?  pagedata.pagecontenten: pagedata.pagecontentar  }}</p>  
  <section class="our-team-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-right">
                <div class="team-member">
                    <div class="row" >
                        <!--Start single team member-->
                        <div class="col-md-3" v-if="$i18n.locale == 'en'" v-for="learningcoursesendata in learningcoursesen"
                                 v-bind:key="learningcoursesendata.id">
                                                    <a :href="'../../../../en/courses/'+learningcoursesendata.id" >


                            <div class="single-team-member">

                                <div class="img-holder" style="text-align:center!important;">
                                    <img style="width: 50%!important;" :src="publicurl+'courses.png'" alt="Courses">

                                </div>
                                <div class="content">
 <h3>{{ learningcoursesendata.titleen}}</h3>                                   
                                    <p dir="rtl" style="text-align: center; color: #404040;">{{ learningcoursesendata.courseencount }} Lessons</p>
                                </div>
                            </div>
                        
                        </a></div>
                                                <div v-if="$i18n.locale == 'ar'"  class="col-md-3" v-for="learningcoursesardata in learningcoursesar"
                                 v-bind:key="learningcoursesardata.id">

                       
                                                <a   :href="'../../../../ar/courses/'+learningcoursesardata.id" >

                            <div class="single-team-member">

                                <div class="img-holder" style="text-align:center!important;">
                                    <img style="width: 50%!important;" :src="publicurl+'courses.png'" alt="Courses">

                                </div>
                                <div class="content">
 <h3>{{ learningcoursesardata.titlear}}</h3>                                   
                                    <p dir="rtl" style="text-align: center; color: #404040;">{{ learningcoursesardata.courseencount }} درس</p>
                                </div>
                            </div>
                        
                        </a></div>



                    </div>

                </div>
            </div>

        </div>
    </div>
</section>         

<!--End faq content area-->
	<!--Start slogan area-->
<section class="slogan-area">
    <div class="container">
        <div class="title pull-center">
            <h2>{{ $i18n.locale == 'en' ? pagefooteren: pagefooterar  }}</h2>    
        </div>
        <div class="buttons pull-right">
        </div>
    </div>    
</section>
<!--End slogan area-->
<!--Start footer area-->  

   
            <Footer/>
 </div>
    </div>
</template>

<script>
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery-1.11.1.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.bxslider.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.countTo.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.appear.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/owl.carousel.min.js";

import  "https://wafrafrontend.marketequityinc.com/src/assets/js/validate.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.mixitup.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.easing.min.js";
import "http://maps.google.com/maps/api/js?sensor=true";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/gmaps.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/map-helper.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.fitvids.js";


import "https://wafrafrontend.marketequityinc.com/src/assets/fancyapps-fancyBox/source/jquery.fancybox.pack.js";		

import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.tools.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.revolution.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.actions.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.carousel.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.kenburn.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.layeranimation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.migration.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.navigation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.parallax.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.slideanims.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.video.min.js";




import "https://wafrafrontend.marketequityinc.com/src/assets/js/custom.js";
</script>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'Home',
    title: 'Home',
    data() {
        return {
            langs: ['en', 'ar'],
           
            homepageblocks: '',
            homeblock1: null,
            homeblockimage1: null,
            homepageblocksicons: [],
            homepageblocksicons3: [],
            homepageblocks2: '',
            ceomessage: '',
            successstories: '',
            slide1image:'',
            slide2image:'',
            slide3image:'',
            techanalysis:'',
            pagedata:'',
            pagebanner:'',
            crosses:'',
            currencydata:'',
            learningcoursesar:'',
            learningcoursesen:''
            

        }
    },
    components: {
        Header,
        Footer
    },
    beforeMount() {
          var pathvalues = (this.$route.path).split("/");
        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'ar';
        }

        this.loadpagedata('learningvideos');
        this.loadlearningvideoswafra();


    },
    mounted() {
        
        this.loadpagedata('learningvideos');
        this.loadlearningvideoswafra();
        this.loaddata();
       
    },

    methods: {
          loaddata() {

            this.$axios.get("loadheaderdata",
            )
                .then(res => {
                    if (res) {

                       
                        this.pagefooteren = res.data.sitesettings[0].pagefooteren;
                        this.pagefooterar = res.data.sitesettings[0].pagefooterar;
                      
                    }
                });
        },
 
 loadlearningvideoswafra() {

            this.$axios.get("http://devbackup.marketequityinc.com/loadlearningvideoswafra",
            )
                .then(res => {
                    if (res) {

                        this.learningcoursesen = res.data.learningcoursesen;
                        this.learningcoursesar = res.data.learningcoursesar;




                    }
                  
                });
        },
      
       loadpagedata(pagename) {
            this.$axios.get("loadpagedata", {
                params: {
                    pagename: pagename
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                          if (res.data.code == 200) {
                        this.pagedata = res.data.pagedata[0];
                        this.pagebanner=this.serverurl+'/public/pagebanners/'+res.data.pagedata[0].pagebanner;
                          }
                        else{

                            this.$router.push({ name: 'NotFound' })
                        }
                    }
                });
            

        },

    }
}
</script>
<style>
#div1::after{
    clear: none!important;
    
}
.carousel {
  background: #2f435700!important;
}
    
</style>
